import { getAllFieldsForSection } from './formJsonSections.js';

export function parseBooleanLike(value, defaultValue = false) {
    if (value == null) return defaultValue;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (['true', '1', 'yes', 'y', 'on'].includes(normalized)) return true;
        if (['false', '0', 'no', 'n', 'off', ''].includes(normalized))
            return false;
    }
    return defaultValue;
}

export function canDisplayAuditScores(audit) {
    const raw = audit?.template?.display_scores ?? audit?.display_scores;
    return parseBooleanLike(raw, true);
}

function hasObservationAndEvidenceFields(formJson) {
    if (!Array.isArray(formJson)) return false;
    return formJson.some((section) => {
        const fields = getAllFieldsForSection(section);
        return fields.some((field) => {
            const observationAndRecommendationEnabled =
                field?.observationAndRecommendation === true;
            if (!observationAndRecommendationEnabled) return false;
            return true;
        });
    });
}

export function isObservationAndEvidenceEligibleAudit(audit) {
    if (!audit) return false;
    if (parseBooleanLike(audit?.observation_and_recommendation_enabled, false))
        return true;
    if (parseBooleanLike(audit?.evidence_reviewed_enabled, false)) return true;
    if (
        parseBooleanLike(
            audit?.template?.observation_and_recommendation_enabled,
            false
        )
    )
        return true;
    if (parseBooleanLike(audit?.template?.evidence_reviewed_enabled, false))
        return true;
    if (hasObservationAndEvidenceFields(audit?.form_json)) return true;
    if (hasObservationAndEvidenceFields(audit?.template?.form_json)) return true;
    return false;
}

export function isAuditVisibleToNonAdmin(audit) {
    if (!audit) return false;
    if (!isObservationAndEvidenceEligibleAudit(audit)) return true;
    return audit?.published_to_client === true;
}
